import { render, staticRenderFns } from "./ManageAreaMatrixQuestions.vue?vue&type=template&id=1b56b666"
import script from "./ManageAreaMatrixQuestions.vue?vue&type=script&lang=js"
export * from "./ManageAreaMatrixQuestions.vue?vue&type=script&lang=js"
import style0 from "./ManageAreaMatrixQuestions.vue?vue&type=style&index=0&id=1b56b666&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports